// extracted by mini-css-extract-plugin
export default {"modalOverlay":"IJ-z","modalContent":"JJ-z","header":"KJ-z","close":"LJ-z"};